<template>
  <div class="customer-create">
    <header-top showBack></header-top>
    <div class="header-title show-back">编辑客源</div>
    <div class="customer-create-main">
      <el-form
        label-position="left"
        label-width="6rem"
        ref="customerForm"
        :rules="customerRules"
        :model="customerForm"
      >
        <div class="create-item">
          <div class="create-item-title">基础信息</div>
          <div class="create-item-main">
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="姓名" prop="name">
                  <el-input
                    v-model="customerForm.name"
                    placeholder="请输入姓名"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                  <el-radio-group v-model="customerForm.gender">
                    <el-radio
                      v-for="item in genderOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNumber">
                  <el-input
                    v-model="customerForm.phoneNumber"
                    placeholder="请输入手机号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="意图" prop="intention">
                  <el-select
                    v-model="customerForm.intention"
                    clearable
                    placeholder="请选择意图"
                  >
                    <el-option
                      v-for="item in intentionOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="用途" prop="usingType">
                  <el-select
                    v-model="customerForm.usingType"
                    clearable
                    placeholder="请选择用途"
                  >
                    <el-option
                      v-for="item in usingTypeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="等级" prop="attentionLevel">
                  <el-select
                    v-model="customerForm.attentionLevel"
                    clearable
                    placeholder="请选择等级"
                  >
                    <el-option
                      v-for="item in attentionLevelOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="来源" prop="sourceType">
                  <el-select
                    v-model="customerForm.sourceType"
                    clearable
                    placeholder="请选择来源"
                  >
                    <el-option
                      v-for="item in sourceTypeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="微信号">
                  <el-input
                    v-model="customerForm.weChat"
                    placeholder="请输入微信号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="QQ">
                  <el-input
                    v-model="customerForm.qq"
                    placeholder="请输入QQ号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="证件号码">
                  <el-input
                    v-model="customerForm.idNumber"
                    placeholder="请输入身份证号后六位"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="备注" class="auto-height margin-right">
              <el-input
                type="textarea"
                v-model="customerForm.more"
                maxlength="200"
                placeholder="请输入备注"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="create-item" v-if="contranctVisible">
          <div class="create-item-title">
            <div>其他联系方式</div>
            <el-button type="primary" icon="el-icon-plus" @click="addContract"
              >添加</el-button
            >
          </div>
          <div class="create-item-main">
            <el-table :data="contracts" border>
              <el-table-column prop="name" label="姓名"> </el-table-column>
              <el-table-column prop="gender" label="性别"> </el-table-column>
              <el-table-column prop="phoneNumbers" label="电话">
                <template slot-scope="scope">
                  <div
                    v-for="(item, index) in scope.row.phoneNumbers"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="weChat" label="微信号">
                <template slot-scope="scope">
                  {{ scope.row.weChat | nullValue }}
                </template>
              </el-table-column>
              <el-table-column prop="qq" label="QQ">
                <template slot-scope="scope">
                  {{ scope.row.qq | nullValue }}
                </template>
              </el-table-column>
              <el-table-column prop="more" label="备注">
                <template slot-scope="scope">
                  {{ scope.row.more | nullValue }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="93" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="
                        editContract(scope.row, scope.$index)
                      "
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      @click.native.prevent="delContract(scope.$index)"
                      type="text"
                      class="del-btn"
                      >移除</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="create-item">
          <div class="create-item-title">求购需求</div>
          <div class="create-item-main">
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="总价" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minTotalPrice">
                      <el-input
                        v-model="customerForm.minTotalPrice"
                        placeholder="最低"
                        clearable
                        type="number"
                      ></el-input>
                    </el-form-item>
                    <span>-</span>
                    <el-form-item prop="maxTotalPrice">
                      <el-input
                        v-model="customerForm.maxTotalPrice"
                        placeholder="最高"
                        clearable
                        type="number"
                      ></el-input>
                    </el-form-item>
                    <span>万元</span>
                  </div>
                </el-form-item>
                <el-form-item label="面积" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minArea">
                      <el-input
                        v-model="customerForm.minArea"
                        placeholder="最低"
                        clearable
                        type="number"
                      ></el-input>
                    </el-form-item>
                    <span>-</span>
                    <el-form-item prop="maxArea">
                      <el-input
                        v-model="customerForm.maxArea"
                        placeholder="最高"
                        clearable
                        type="number"
                      ></el-input>
                    </el-form-item>
                    <span>㎡</span>
                  </div>
                </el-form-item>
                <el-form-item label="居室" prop="houseTypes">
                  <el-checkbox-group v-model="customerForm.houseTypes">
                    <el-checkbox
                      v-for="item in houseTypesOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="楼层" prop="floorTypes">
                  <el-checkbox-group v-model="customerForm.floorTypes">
                    <el-checkbox
                      v-for="item in floorTypesOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="朝向" prop="orientationType">
                  <el-checkbox-group v-model="customerForm.orientationType">
                    <el-checkbox
                      v-for="item in orientationTypeOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="付款方式">
                  <el-select
                    v-model="customerForm.payType"
                    clearable
                    placeholder="请选择付款方式"
                  >
                    <el-option
                      v-for="item in payTypeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="交通">
                  <el-input
                    v-model="customerForm.traffic"
                    placeholder="请输入交通"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="装修">
                  <el-checkbox-group v-model="customerForm.decorations">
                    <el-checkbox
                      v-for="item in decorationsOptions"
                      :label="item"
                      :key="item"
                      >{{ item }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="购房目的">
                  <el-input
                    v-model="customerForm.buyPurpose"
                    placeholder="请输入购房目的"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="预计入学时间">
                  <el-date-picker
                    align="center"
                    v-model="customerForm.schoolTime"
                    type="date"
                    placeholder="请选择预计入学时间"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="意向学校" class="auto-height">
              <el-tag
                :key="index"
                v-for="(tag, index) in customerForm.schools"
                closable
                :disable-transitions="false"
                @close="delSchoolTag(tag)"
              >
                <span>{{ tag }}</span>
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="schoolVisible"
                v-model="inputValue"
                ref="schoolTagInput"
                @keyup.enter.native="handleInputSchool"
                @blur="handleInputSchool"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                icon="el-icon-plus"
                @click="showSchool"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item label="意向商圈" class="auto-height" prop="addresses">
              <el-tag
                :key="index"
                v-for="(tag, index) in customerForm.addresses"
                closable
                :disable-transitions="false"
                @close="delAddressTag(tag)"
              >
                <span>
                  {{ tag.city }}
                  -
                  {{ tag.district }}
                  -
                  {{ tag.street }}
                  -
                  {{ tag.business }}
                </span>
              </el-tag>
              <el-cascader
                v-if="addressVisible"
                :options="addressOptions"
                @change="handleInputAddress"
                v-model="addressValue"
              ></el-cascader>
              <el-button
                v-else
                class="button-new-tag"
                icon="el-icon-plus"
                @click="showAddress"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item
              label="意向小区"
              class="auto-height"
              prop="communities"
            >
              <el-tag
                :key="index"
                v-for="(tag, index) in customerForm.communities"
                closable
                :disable-transitions="false"
                @close="delCommunitieTag(tag)"
              >
                <span>{{ tag }}</span>
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="communitieVisible"
                v-model="inputValue"
                ref="communitieTagInput"
                @keyup.enter.native="handleInputCommunitie"
                @blur="handleInputCommunitie"
              >
              </el-input>
              <el-button
                v-else
                class="button-new-tag"
                icon="el-icon-plus"
                @click="showCommunitie"
                >添加</el-button
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="create-btns">
        <el-button @click="cancel">取 消</el-button>
        <el-button
          type="primary"
          @click="submitCustomerForm"
          :loading="isLoading"
          >保 存</el-button
        >
      </div>
    </div>
    <el-dialog
      :title="contractTitle"
      :visible.sync="isContracShow"
      @close="handleClose('contractForm')"
    >
      <el-form
        label-position="left"
        label-width="5rem"
        ref="contractForm"
        :rules="contractRules"
        :model="contractForm"
      >
        <div class="flex-items">
          <div class="flex-item">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="contractForm.name"
                placeholder="请输入姓名"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="contractForm.gender">
                <el-radio
                  v-for="item in genderOptions"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号1" prop="phone1">
              <el-input
                v-model="contractForm.phone1"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-item">
            <el-form-item label="微信号" prop="weChat">
              <el-input
                v-model="contractForm.weChat"
                placeholder="请输入微信号"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="QQ" prop="qq">
              <el-input
                v-model="contractForm.qq"
                placeholder="请输入QQ号"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="手机号2" prop="phone2">
              <el-input
                v-model="contractForm.phone2"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="备注" class="auto-height" prop="more">
          <el-input
            type="textarea"
            maxlength="200"
            v-model="contractForm.more"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="isContracShow = false">取 消</el-button>
          <el-button type="primary" @click="submitContractForm"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { validatePhone } from "@/utils/validate";
import { deepCopy } from "@/utils/deepCopy";
import {
  getCustomerInfo,
  updateCustomer,
  getCustomerPhone,
  getContractPhone,
} from "@/http/api/customer";
import { dateFormat } from "@/common/filters";
import { areaSearchAllTree } from "@/http/api/area";
import { customerSettings,estateSettings } from "@/http/api/system";
import {getEnumValues} from "@/utils/getEnumMeta";

export default {
  components: {
    headerTop,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validatePhone2Number = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不正确"));
      } else {
        callback();
      }
    };
    const validateMaxTotalPrice = (rule, value, callback) => {
      let min = this.customerForm.minTotalPrice;
      if (!value) {
        callback(new Error("请输入总价最高值"));
      }
      if (Number(min) > 0 && Number(min) > Number(value)) {
        callback(new Error("总价最高值不能低于总价最低值"));
      } else {
        callback();
      }
    };
    const validateMinTotalPrice = (rule, value, callback) => {
      let max = this.customerForm.maxTotalPrice;
      if (!value) {
        callback(new Error("请输入均价最低值"));
      }
      if (Number(max) > 0 && Number(value) > Number(max)) {
        callback(new Error("均价最低值不能高于均价最高值"));
      } else {
        callback();
      }
    };
    const validateMaxArea = (rule, value, callback) => {
      let min = this.customerForm.minArea;
      if (!value) {
        callback(new Error("请输入面积最高值"));
      }
      if (Number(min) > 0 && Number(min) > Number(value)) {
        callback(new Error("面积最高值不能低于总价最低值"));
      } else {
        callback();
      }
    };
    const validateMinArea = (rule, value, callback) => {
      let max = this.customerForm.maxArea;
      if (!value) {
        callback(new Error("请输入面积最低值"));
      }
      if (Number(max) > 0 && Number(value) > Number(max)) {
        callback(new Error("面积最低值不能高于均价最高值"));
      } else {
        callback();
      }
    };
    return {
      id: "",
      contractTitle: "",
      contractIndex: "",
      isContracShow: false,
      isLoading: false,
      communitieVisible: false,
      schoolVisible: false,
      addressVisible: false,
      contranctVisible: false,
      inputValue: "",
      permissions: {},
      customerForm: {
        name: "",
        intention: "",
        usingType: "",
        gender: "女",
        phoneNumber: "",
        attentionLevel: "",
        sourceType: "",
        weChat: "",
        qq: "",
        idNumber:'',
        more: "",
        minTotalPrice: "",
        maxTotalPrice: "",
        minArea: "",
        maxArea: "",
        houseTypes: [],
        floorTypes: [],
        orientationType: [],
        schoolTime: "",
        payType: "",
        traffic: "",
        decorations: [],
        buyPurpose: "",
        schools: [],
        communities: [],
        addresses: [],
      },
      contractForm: {
        name: "",
        gender: "女",
        phone1: "",
        phone2: "",
        weChat: "",
        qq: "",
        more: "",
        phoneNumbers: [],
      },
      schoolForm: {
        name: "",
      },
      customerRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入姓名",
          },
        ],
        gender: [
          {
            required: true,
            trigger: "change",
            message: "请选择性别",
          },
        ],
        phoneNumber: [
          {
            required: true,
            trigger: "blur",
            validator: validatePhoneNumber,
          },
        ],
        intention: [
          {
            required: true,
            trigger: "change",
            message: "请选择意图",
          },
        ],
        attentionLevel: [
          {
            required: true,
            trigger: "change",
            message: "请选择等级",
          },
        ],
        sourceType: [
          {
            required: true,
            trigger: "change",
            message: "请选择来源",
          },
        ],
        usingType: [
          {
            required: true,
            trigger: "change",
            message: "请选择用途",
          },
        ],
        minTotalPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMinTotalPrice,
          },
        ],
        maxTotalPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMaxTotalPrice,
          },
        ],
        minArea: [
          {
            required: true,
            trigger: "blur",
            validator: validateMinArea,
          },
        ],
        maxArea: [
          {
            required: true,
            trigger: "blur",
            validator: validateMaxArea,
          },
        ],
        houseTypes: [
          {
            required: true,
            trigger: "change",
            message: "请选择居室",
          },
        ],
        communities: [
          {
            required: true,
            trigger: "blur",
            message: "请添加小区",
          },
        ],
        addresses: [
          {
            required: true,
            trigger: "change",
            message: "请添加商圈",
          },
        ],
      },
      contractRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入姓名",
          },
        ],
        gender: [
          {
            required: true,
            trigger: "change",
            message: "请选择性别",
          },
        ],
        phone1: [
          {
            required: true,
            trigger: "blur",
            validator: validatePhoneNumber,
          },
        ],
        phone2: [
          { required: false, trigger: "blur", validator: validatePhone2Number },
        ],
        weChat: [{ required: false }],
        qq: [{ required: false }],
        more: [{ required: false }],
      },
      schoolRules: {
        name: [{ required: true, trigger: "blur", message: "请输入学校名称" }],
      },
      contracts: [],
      addressValue: [],
      intentionOptions: [],
      usingTypeOptions: [],
      genderOptions: ["男", "女"],
      attentionLevelOptions: [],
      sourceTypeOptions: [],
      houseTypesOptions: [],
      floorTypesOptions: [],
      orientationTypeOptions: [],
      payTypeOptions: [],
      decorationsOptions: [],
      addressOptions: [],
    };
  },
  methods: {
    // 基础配置项初始化
    initSettings(){
      customerSettings().then((res) => {
        let data=res.result;
        this.payTypeOptions=getEnumValues(data, "Deer.Customer.Collection.PayType");
        this.houseTypesOptions=getEnumValues(data, "Deer.Customer.Collection.HouseType");
        this.floorTypesOptions=getEnumValues(data, "Deer.Customer.Collection.FloorType");
        this.intentionOptions=getEnumValues(data, "Deer.Customer.Collection.IntentionType");
        this.sourceTypeOptions=getEnumValues(data, "Deer.Customer.Collection.SourceType");
        this.attentionLevelOptions=getEnumValues(data, "Deer.Customer.Collection.AttentionLevelType");
      });
      estateSettings().then(res=>{
        let data=res.result;
        this.decorationsOptions=getEnumValues(data, "Deer.Estate.Collection.DecorationType");
        this.orientationTypeOptions=getEnumValues(data, "Deer.Estate.Collection.OrientationType");
        this.usingTypeOptions=getEnumValues(data, "Deer.Estate.Collection.UsingType");
      })
    },
    areaSearchAllTree() {
      areaSearchAllTree().then((res) => {
        let arr = res.result.items;
        arr.map((el) => {
          el.value = el.data.name;
          el.label = el.data.name;
          el.children.map((item) => {
            item.value = item.data.name;
            item.label = item.data.name;
            item.children.map((e) => {
              e.value = e.data.name;
              e.label = e.data.name;
              e.children.map((ele) => {
                ele.value = ele.data.name;
                ele.label = ele.data.name;
                delete ele.children;
              });
            });
          });
        });
        this.addressOptions = arr;
      });
    },
    // 删除商圈
    delAddressTag(tag) {
      this.customerForm.addresses.splice(
        this.customerForm.addresses.indexOf(tag),
        1
      );
    },
    // 出现商圈选择框
    showAddress() {
      this.addressVisible = true;
    },
    // 商圈意向确认回调
    handleInputAddress() {
      let arr = {
        city: this.addressValue[0],
        district: this.addressValue[1],
        street: this.addressValue[2],
        business: this.addressValue[3],
      };
      if (
        JSON.stringify(this.customerForm.addresses).indexOf(
          JSON.stringify(arr)
        ) == -1
      ) {
        this.customerForm.addresses.push(arr);
      }
      this.addressVisible = false;
      this.addressValue = [];
    },
    // 删除小区
    delCommunitieTag(tag) {
      this.customerForm.communities.splice(
        this.customerForm.communities.indexOf(tag),
        1
      );
    },
    // 出现小区输入框
    showCommunitie() {
      this.communitieVisible = true;
      this.$nextTick((_) => {
        this.$refs.communitieTagInput.$refs.input.focus();
      });
    },
    // 学校意向确认回调
    handleInputCommunitie() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.customerForm.communities.push(inputValue);
      }
      this.communitieVisible = false;
      this.inputValue = "";
    },
    // 删除学校
    delSchoolTag(tag) {
      this.customerForm.schools.splice(
        this.customerForm.schools.indexOf(tag),
        1
      );
    },
    // 出现学校输入框
    showSchool() {
      this.schoolVisible = true;
      this.$nextTick((_) => {
        this.$refs.schoolTagInput.$refs.input.focus();
      });
    },
    // 学校意向确认回调
    handleInputSchool() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.customerForm.schools.push(inputValue);
      }
      this.schoolVisible = false;
      this.inputValue = "";
    },
    // 提交客源表单
    submitCustomerForm() {
      this.$refs["customerForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.customerForm);
          if (!data.orientationType) {
            delete data.orientationType;
          }
          if (!data.schoolTime) {
            delete data.schoolTime;
          } else {
            data.schoolTime = dateFormat(data.schoolTime);
          }
          if (this.contracts.length) {
            data.contracts = this.contracts;
          }
          updateCustomer(this.id, data)
            .then((res) => {
              if (res) {
                if (res) {
                  this.$message.success({
                    message: "保存成功",
                    showClose: true,
                  });
                }
                this.$router.push({ name: "customerList" });
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 取消返回
    cancel() {
      this.$confirm(`您确定不保留数据回到列表页吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$router.push({ name: "customerList" });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 移除联系人
    delContract(index) {
      this.$confirm(`是否移除该联系人？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.contracts.splice(index, 1);
          this.$message.success({ message: "移除成功", showClose: true });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 编辑联系人
    editContract(v, i) {
      this.contractTitle = "编辑联系人";
      v.phone1 = v.phoneNumbers[0];
      v.phone2 = "";
      if (v.phoneNumbers[1]) {
        v.phone2 = v.phoneNumbers[1];
      }
      this.contractForm = deepCopy(v);
      this.contractIndex = i;
      this.isContracShow = true;
    },
    // 提交联系人表单
    submitContractForm() {
      this.$refs["contractForm"].validate((valid) => {
        if (valid) {
          let data = deepCopy(this.contractForm);
          data.phoneNumbers = [data.phone1];
          if (data.phone2) {
            data.phoneNumbers.push(data.phone2);
          }
          delete data.phone1;
          delete data.phone2;
          //console.log(data, "data");
          if (this.contractTitle == "添加联系人") {
            this.contracts.push(data);
          } else {
            this.contracts.splice(this.contractIndex, 1, data);
          }
          this.isContracShow = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 添加联系人
    addContract() {
      this.contractTitle = "添加联系人";
      this.isContracShow = true;
    },
    // 弹窗关闭回调
    handleClose(formName) {
      this.$refs[formName].resetFields();
      Object.assign(this.$data.contractForm, this.$options.data().contractForm);
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.areaSearchAllTree();
    this.initSettings();
    getCustomerInfo(this.id).then((res) => {
      this.customerForm = res.result;
      this.contracts = this.customerForm.contracts;
      this.permissions = this.$store.getters.permissions;
      if (this.permissions["Customer.LookPhoneNumber"]) {
        getCustomerPhone(this.id).then((res) => {
          //console.log(res, "电话");
          this.customerForm.phoneNumber = res.result;
        });
        getContractPhone(this.id).then((res) => {
          //console.log(res, "联系人");
          this.contracts = res.result.items;
        });
      }
      if (this.permissions["Customer.LookContract"]) {
        this.contranctVisible = true;
      } else {
        this.contranctVisible = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.customer-create {
  .customer-create-main {
    padding: 20px;

    .create-item {
      margin-bottom: 20px;
      border-radius: $--border-radius-base;
      background: #ffffff;

      .create-item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 20px;
        border-bottom: 1px solid #e0e0e0;

        font-size: 16px;
        font-weight: bold;
        color: #7d7d7d;
      }

      .create-item-main {
        padding: 20px;

        .el-input,.el-select {
          width: 330px;
        }
        .min-input {
          .el-input {
            width: 220px;
          }
        }

        .margin-right {
          margin-right: 80px;
        }

        .el-textarea {
          ::v-deep .el-textarea__inner {
            height: 87px;
          }
        }

        ::v-deep .el-table {
          .el-table__header {
            th {
              background-color: #f7f7f7;
            }

            th {
              padding: 9px 0;
            }
          }

          td {
            padding: 9px 0;
          }
        }

        .flex-form {
          display: flex;
          span {
            margin: 0 10px;
          }
        }

        ::v-deep .el-date-editor {
          .el-icon-date {
            left: 290px;
          }
        }

        .add-btn:hover {
          color: $--color-primary;
        }

        ::v-deep .el-tag {
          height: 30px;
          margin-right: 10px;
          span {
            position: relative;
            bottom: 1px;
          }

          .el-tag__close {
            position: relative;
            top: -2px;
          }
        }

        .button-new-tag {
          height: 30px;
          line-height: 28px;
          padding-top: 0;
          padding-bottom: 0;
        }

        .input-new-tag {
          width: 90px;
          box-sizing: border-box;
          vertical-align: bottom;
        }
      }
    }
  }

  .flex-items {
    display: flex;
    .flex-item {
      width: 50%;
    }
  }

  .create-btns {
    border-radius: $--border-radius-base;
    padding: 20px;
    text-align: center;
    background: #fff;

    .el-button {
      width: 140px;
    }
  }

  .el-dialog {
    .flex-item {
      &:first-child {
        margin-right: 50px;
      }

      margin-bottom: 20px;
    }
  }
}
</style>